export class AttributeCommunity {
    public id: number;
    public financialCommunityId: number;
    public attributeMarketId: number;
    public description: string;
    public manufacturer: string;
    public sku: string;
    public createdUtcDate: Date;
    public createdBy: string;
    public lastModifiedUtcDate: Date;
    public lastModifiedBy: string;
}